import TranslationWrapper from "./TranslationWrapper/TranslationWrapper";
import React from "react";
import { Link, Alert } from "@mui/material";

export function UsingOtherSalesareaForStylingAlert({ styling_salesarea_id }: { styling_salesarea_id: number }) {
  return (
    <Alert severity={"warning"}>
      <TranslationWrapper
        tDefault={"Warning: Styling of other salesarea is used!"}
        tKey={"vestigingen.form.branding.headers.stylingVestigingIdInUse"}
      />
      <p>
        <Link href={`/manager/vestigingen/${styling_salesarea_id}/edit`}>Open</Link> - #{styling_salesarea_id}
      </p>
    </Alert>
  );
}
